import React from "react";
import { Navigate } from "react-router-dom";
import PrivacyV14Document from "./documents/PrivacyV14Document";
import { PRIVACY_V14_EFFECTIVE_AT, PRIVACY_V14_NOTICE_START_AT } from "./clauseVersionDates";

const CHANGE_ROWS: [string, string][] = [
  ["관심고객 정보 전달 항목 추가", "관심고객 정보 전달(이름, 전화번호, 이메일, 네이버회원 식별정보) 추가"],
  ["광고성 정보 수신(선택) 추가", "신규 서비스·이벤트·프로모션 등 광고성 정보 전달"],
  ["제3자 제공 항목 수정", "제공 목적(관심 고객 정보 전달, 이벤트 안내) 및 법적 근거(제17조 제1항 제1호) 수정"],
];

const BiztingPrivacyPolicyV14Page = () => {
  const now = new Date();
  const isV14Effective = now >= PRIVACY_V14_EFFECTIVE_AT;

  if (now < PRIVACY_V14_NOTICE_START_AT) {
    return <Navigate replace to="/clause/privacy" />;
  }

  return (
    <PrivacyV14Document
      mode={isV14Effective ? "current" : "scheduled"}
      modal={isV14Effective ? undefined : {
        title: "이전 버전 대비 변경사항 요약",
        subtitle: "공고일자: 2026.09.28 · 시행일자: 2026.10.28",
        ctaLabel: "확인",
        content: (
          <div className="modal-section">
            <div className="modal-section-title">{"주요 변경 조항"}</div>
            <table className="modal-tbl">
              <thead><tr><th>{"조항"}</th><th>{"내용"}</th></tr></thead>
              <tbody>
                {CHANGE_ROWS.map(([tag, text], i) => (
                  <tr key={i}><td style={{ fontWeight: 600 }}>{tag}</td><td>{text}</td></tr>
                ))}
              </tbody>
            </table>
            <p style={{ fontSize: "12.5px", color: "var(--text-muted)", marginTop: "10px" }}>
              {"* 본 안내 일부터 1개월 이내에 이의제의가 없을 경우, 개정 내용에 동의하신 것으로 판단됩니다."}
            </p>
          </div>
        ),
      }}
    />
  );
};

export default BiztingPrivacyPolicyV14Page;
